import { LCLChargesCompFromNew } from "../quick-quotev3/editchargenew";
import { useSnapshot } from "valtio"
import { chargesBookingValidationStore } from "../mybooksv3/booking-commonstate"
import { bookingsStore, cargoStore, configStore, contractsStore, loginStore } from "../state/CommonState";
import { useEffect, useMemo, useState } from "react";
import Utils from "../util/Utils";
import { chargesData1 } from "../StaticData";
import { loader } from "../util/loader.js";
import {  PERMISSIONS_NEW } from "../util/constants.js";
import RoleUtils from "../util/RoleUtils.js";
import TenantUtils from "../util/tenant.utils.js";
import {  FormProvider,  useForm,  useWatch } from "react-hook-form";
import MonApi, { GET_BOOKINGS_LIST_URI, UPDATE_BOOKING_DATA_BY_ID_URI } from '../state/mongo-api';

export default function Edit_PKB_REBATE(props) {
    useSnapshot(contractsStore)
    useSnapshot(bookingsStore)
    useSnapshot(loginStore)
    const [show, setShow] = useState(false)
    const charges = useForm({
        defaultValues:{
            groupedByCategory:{},
            rebate:[],
            pkb:[]
        }
    })
    const { control, setValue } = charges;
    

    const watchedRebate = useWatch({
      control,
      name: 'rebate',
    });

    const watchedPkb = useWatch({
      control,
      name: 'pkb',
    });

    const req = useMemo(() => {
 
      let showsave = false
      if(contractsStore.current!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
        let l = JSON.parse(JSON.stringify(contractsStore.current))
        let l1 = {}
        if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
            l1['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
            l1['pkb'][0]['isIncluded'] = 'Yes'
        }
        if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
            l1['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
            l1['rebate'][0]['isIncluded'] = 'Yes'
        }
        const check = (o,o1,k)=>{
            if(o[k]!=undefined && o[k][0]["total"]!=undefined && o[k][0]['total']!=0 && o1[k]==undefined){
                return true
            }else if(o[k]!=undefined && o1[k]!=undefined && o[k].length != 0 && JSON.stringify(o[k])!=JSON.stringify(o1[k])){
                return true
            }else{
                return false
            }
        }
        if(bookingsStore.current._id !=undefined && (check(l,l1,'pkb') || check(l,l1,'rebate'))){
            showsave = true
        }else{
            showsave = false
        }
      }

      return { showsave };
    }, [watchedPkb,watchedRebate,contractsStore.current]);
    
    
        const save = async ()=>{
        loader.show()
        let l = JSON.parse(JSON.stringify(contractsStore.current))
        let l1 = {}
        l1['tsCreatedOn'] = Date.now()
        l1['tsCreatedBy'] = loginStore.email
        if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
            l1['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
            l1['pkb'][0]['isIncluded'] = 'Yes'
        }
        if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
            l1['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
            l1['rebate'][0]['isIncluded'] = 'Yes'
        }
        const check = (o,o1,k)=>{
            if(o[k]!=undefined && o[k][0]["total"]!=undefined && o[k][0]['total']!=0 && o1[k]==undefined){
                return true
            }else if(o[k]!=undefined && o1[k]!=undefined && o[k].length != 0 && JSON.stringify(o[k])!=JSON.stringify(o1[k])){
                return true
            }else{
                return false
            }
        }
        if(bookingsStore.current._id !=undefined){
            let k = {}
            if(check(l,l1,'pkb')){
                l1['pkb'] = l1['pkb']!=undefined?l1['pkb']:JSON.parse(JSON.stringify(watchedPkb))
                k['contract.pkb'] = l1['pkb']
                bookingsStore.current.contract.pkb = JSON.parse(JSON.stringify(l1['pkb']))
                contractsStore.current.pkb = JSON.parse(JSON.stringify(l1['pkb']))
            }
            if(check(l,l1,'rebate')){
                l1['rebate'] = l1['rebate']!=undefined?l1['rebate']:JSON.parse(JSON.stringify(watchedRebate))
                k['contract.rebate'] = l1['rebate']
                bookingsStore.current.contract.rebate = JSON.parse(JSON.stringify(l1['rebate']))
                contractsStore.current.rebate = JSON.parse(JSON.stringify(l1['rebate']))
            }
            setShow(false)
            let b = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: bookingsStore.current._id
})
            if(b.length>0){
                b = b[0]
                if(b['pkb_rebate_logs']==undefined){
                    k['pkb_rebate_logs']=[l1]
                }else{
                    k['pkb_rebate_logs'] = b['pkb_rebate_logs']
                    k['pkb_rebate_logs'].push(l1)
                }
                await MonApi.apost(UPDATE_BOOKING_DATA_BY_ID_URI, {
  _id: bookingsStore.current._id,
  updateData: k
})
                configStore.setModalMessage(`charges saved successfully`);
            }
        }
        loader.hide()
    }
    
    useEffect(()=>{
        if(!show && JSON.stringify(contractsStore.current)!=JSON.stringify({})){
          chargesBookingValidationStore.isNew = true
        if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(contractsStore.current.cargoList)){
            cargoStore.cargoList = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
        }
        cargoStore.calculateCargoTotals()
        let type = contractsStore.current.shipmentType
        let scope = contractsStore.current.shipmentScope
        const data1 = chargesData1[type.toLowerCase()+scope.toLowerCase()];
        if(type.toLowerCase() == 'lcl'){
        if(contractsStore.current.rebate==undefined || contractsStore.current.rebate.length==0 || Object.keys(contractsStore.current.rebate).length==0){
            setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
            contractsStore.current.rebate = JSON.parse(JSON.stringify(data1.rebate))
        }else{
            let rebate = contractsStore.current.rebate
            if(Utils.isObject(contractsStore.current.rebate)){
                rebate = [contractsStore.current.rebate]
                rebate[0]['category'] = 'REBATE'
            }
            if(rebate[0]['chargeDescription']=='Rebate'){
                setValue('rebate',JSON.parse(JSON.stringify(rebate)))
            }else{
                setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
                contractsStore.current.rebate = JSON.parse(JSON.stringify(data1.rebate))
            }
            if(JSON.stringify(contractsStore.current.rebate)!=JSON.stringify(rebate)){
                contractsStore.current.rebate = JSON.parse(JSON.stringify(rebate))
            }
        }
        if(contractsStore.current.pkb==undefined || contractsStore.current.pkb.length==0){
            setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
            contractsStore.current.pkb = JSON.parse(JSON.stringify(data1.pkb))
        }else{
            let pkb = contractsStore.current.pkb
            if(Utils.isObject(contractsStore.current.pkb)){
                pkb = [contractsStore.current.pkb]
                pkb[0]['category'] = 'PKB'
            }
            if(pkb[0]['chargeDescription']=='Freight Commission'){
                setValue('pkb',JSON.parse(JSON.stringify(pkb)))
            }else{
                setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
                contractsStore.current.pkb = JSON.parse(JSON.stringify(data1.pkb))
            }
            if(JSON.stringify(contractsStore.current.pkb)!=JSON.stringify(pkb)){
                contractsStore.current.pkb = JSON.parse(JSON.stringify(pkb))
            }
            }
        }
        setShow(true)
        }
    },[JSON.stringify(contractsStore.current)])
    
   
    return (<>{ show &&<>

                

              
<div class="columns is-multiline">
    <FormProvider {...charges}>  
  <div class="column is-12">
    {(TenantUtils.isNavexel()) && <>
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.REBATE) && <LCLChargesCompFromNew hidehr={true} form={charges} listkey={"rebate"} hide={true} contract={contractsStore.current}/>}
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.PKB) && <LCLChargesCompFromNew hidehr={true} form={charges} listkey={"pkb"} hide={true} contract={contractsStore.current}/>}
    </>}

</div>  
</FormProvider>  
<div class="column is-12">
{req.showsave && <><div className="control" style={{textAlign:"right"}}>
                                <button className="button"
                                 style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                    onClick={()=>{save()}}>
                                    Save
                                </button>
                            </div><br /></>}
</div>
</div>   
        
    </>}</>)
}